import { AppState } from '../AppTypes';

export const _flagEnabled = (state: AppState) => {
  return (flag: string, defaultValue?: boolean): boolean => {
    if (import.meta.env.DEV) {
      return state.flags.includes(flag);
    }
    return state.ldClient.variation(flag, defaultValue) === true;
  };
};
